import { motion } from 'motion/react';
import { PAGE_TRANSITION } from 'src/lib/motion.ts';

export function PageMotion({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={PAGE_TRANSITION}>
      {children}
    </motion.div>
  );
}
